import { Event, EventStatus } from '../../../../services';
import { isEventPast } from '../../../utils';

export const hasEventStatusBadges = (event: Event): boolean => {
  const {
    endAt,
    participantCountConfirmed,
    participantsCapacity,
    participantStatus,
    startAt,
    status,
  } = event;

  return (
    participantStatus !== null ||
    (participantsCapacity > 0 && participantCountConfirmed >= participantsCapacity) ||
    isEventPast(startAt, endAt) ||
    status === EventStatus.CANCELLED
  );
};
